import type { taskEither } from "fp-ts";

import type {
  Approve,
  Common,
  Create,
  Delete,
  Get,
  GetByOrder,
  GetPaginated,
  GetPaginatedForAdmin,
  Update,
} from "./ios";

import type { AuthenticationError, NotFoundError, UnexpectedError } from "~/shared/error";

abstract class Provider {
  abstract create(
    params: Create.In,
  ): taskEither.TaskEither<UnexpectedError | NotFoundError, Common.OutSchema>;
  abstract update(
    params: Update.In,
  ): taskEither.TaskEither<
    UnexpectedError | AuthenticationError | NotFoundError | Update.Error,
    Common.OutSchema
  >;
  abstract delete(
    params: Delete.In,
  ): taskEither.TaskEither<UnexpectedError | AuthenticationError | NotFoundError, void>;
  abstract approve(
    params: Approve.In,
  ): taskEither.TaskEither<UnexpectedError | AuthenticationError | NotFoundError, void>;
  abstract get(
    params: Get.In,
  ): taskEither.TaskEither<UnexpectedError | NotFoundError, Common.OutSchema>;
  abstract getForAdmin(
    params: Get.In,
  ): taskEither.TaskEither<
    UnexpectedError | AuthenticationError | NotFoundError,
    Common.OutSchema2
  >;
  abstract getPaginated(
    params: GetPaginated.In,
  ): taskEither.TaskEither<UnexpectedError, GetPaginated.Out>;
  abstract getPaginatedForAdmin(
    params: GetPaginatedForAdmin.In,
  ): taskEither.TaskEither<UnexpectedError, GetPaginatedForAdmin.Out>;
  abstract getByOrder(
    params: GetByOrder.In,
  ): taskEither.TaskEither<UnexpectedError | NotFoundError, GetByOrder.Out>;
}

export { Provider };
